// Where the Academy's audio lives: a PRIVATE S3 bucket
// (`police-narratives-ai-academy`, same name in the commercial and GovCloud
// partitions; SOC 2 means nothing is public-read), not the repo and not the
// client image. Clips are requested through the app itself,
// `/api/academy/assets/<narration|samples>/<file>.mp3`, which checks the
// session and redirects to a short-lived presigned URL (academyRouter.ts), so
// <audio>, fetch, and <a download> behave as if the files were public but only
// a signed-in session can read them. The narration manifests (tiny JSON,
// written by `yarn academy:narrate`) stay in the repo under
// client/public/academy/narration/<sceneId>/manifest.json and are served from
// the app; each manifest names the mp3 files, which come from here. Override
// with REACT_APP_ACADEMY_ASSETS_URL only to point at a different host.
export const ACADEMY_ASSETS_URL = (process.env.REACT_APP_ACADEMY_ASSETS_URL || "/api/academy/assets").replace(/\/+$/, "");

/**
 * The same file in the repo's local staging folder (client/public/academy),
 * for a file that is not in the bucket yet: a clip or sample just generated
 * and not published. Dev servers serve that folder; production does not
 * (the mp3s are gitignored and out of the image), so there it is only a miss.
 * Takes the URL as written or as an element reports it (`audio.src` is
 * absolute even when the clip was set to a relative path).
 */
export function localFallback(url: string): string | null {
  const base = typeof window !== "undefined" && ACADEMY_ASSETS_URL.startsWith("/") ? `${window.location.origin}${ACADEMY_ASSETS_URL}` : ACADEMY_ASSETS_URL;
  for (const prefix of [`${ACADEMY_ASSETS_URL}/`, `${base}/`]) {
    if (url.startsWith(prefix)) return `/academy/${url.slice(prefix.length).split("?")[0]}`;
  }
  return null;
}
